//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApartmentTooltip from '../partials/ApartmentTooltip.vue';
import { isMobile } from 'mobile-device-detect';
export default {
  name: 'Selector',
  props: ['apartments'],
  components: {
    'apartment-tooltip': ApartmentTooltip,
  },
  data: function() {
    return {
      mobile: isMobile,
      points: [
        {
          id: 'X1',
          path:
            'M599.94 651.883L598.774 620.326L600.942 621.159L701.272 664.886L700.341 698.55L599.94 651.883Z',
        },
        {
          id: 'X2',
          path:
            'M700.341 698.55L701.272 664.886L809.188 713.139L803.498 743.597L700.341 698.55Z',
        },
        {
          id: 'X3',
          path:
            'M803.498 743.597L809.188 713.139L926.184 762.465L915.622 793.224L803.498 743.597Z',
        },
        {
          id: 'X4',
          path:
            'M915.622 793.224L926.184 762.465L1051.95 815.11L1033.83 848.191L915.622 793.224Z',
        },
        {
          id: 'X5',
          path:
            'M1051.95 815.11L1187.21 878.127L1163.91 906.693L1033.83 848.191L1051.95 815.11Z',
        },
        {
          id: 'X1B',
          path:
            'M599 620.326L597.549 586.963L605.741 563.333L642.062 469.931L749.673 507.579L701.498 632.56L701.272 664.886L599 620.326Z',
        },
        {
          id: 'X2B',
          path:
            'M701.272 664.886V630.503L749.673 507.579L864.841 552.828L814.612 678.773L809.188 713.139L701.272 664.886Z',
        },
        {
          id: 'X3B',
          path:
            'M809.188 713.139L814.612 678.773L864.841 552.828L993.395 600.566L937.446 729.68L926.184 762.465L809.188 713.139Z',
        },
        {
          id: 'X4B',
          path:
            'M926.184 762.465L937.446 729.68L993.394 600.565L1132.51 654.176L1069.6 787.824L1054.84 815.11L926.184 762.465Z',
        },
        {
          id: 'X5B',
          path:
            'M1054.84 815.11L1069.6 787.824L1132.51 654.176L1282.49 709.954L1211.33 848.191L1187.21 878.127L1054.84 815.11Z',
        },
        {
          id: 'Y1',
          path:
            'M455.5 553.5L520 478.5L523 515L459.5 585L351.533 541.651L341 506L455.5 553.5Z',
        },
        {
          id: 'Y2',
          path:
            'M564.846 458.654L563.5 426.5L520 478.5L523 515L564.846 458.654Z',
        },
        {
          id: 'Y3',
          path: 'M563.5 426.5L603 379.5L605 407.5L565 458.5L563.5 426.5Z',
        },
        {
          id: 'Y4',
          path: 'M603 379.5L639 336L639 362L605 407.5L603 379.5Z',
        },
        {
          id: 'Y5',
          path: 'M670 322.705L670 298.5L639 336V362L670 322.705Z',
        },
        {
          id: 'Y1B',
          path:
            'M517 451L520 478.5L455.5 553.5L341 506L330.5 474.5L371.5 431L437.5 362.5L517 451Z',
        },
        {
          id: 'Y2B',
          path:
            'M437.5 362.5L517 451L520 478.5L563.5 426.5L561.466 393.684L489 310.5L437.5 362.5Z',
        },
        {
          id: 'Y3B',
          path:
            'M489 310.5L561.466 393.684L563.5 426.5L603 379.5L600.899 342.609L534.5 265.5L489 310.5Z',
        },
        {
          id: 'Y4B',
          path:
            'M603 379.5L600.898 342.609L534.5 265.5L574 226.5L638.5 303L639 336L603 379.5Z',
        },
        {
          id: 'Y5B',
          path:
            'M670 260.363L615.5 185.5L574 226.5L638.5 303L639 336L670 298.5V260.363Z',
        },
        {
          id: 'U1',
          path: 'M522.5 157.5L492.5 183L494.5 213L523.5 186L522.5 157.5Z',
        },
        {
          id: 'U3',
          path: 'M421.5 246.5L458.5 214L462 241.5L426.5 272.5L421.5 246.5Z',
        },
        {
          id: 'U3B',
          path:
            'M455 183L458.5 214L421.5 246.5L415 213.5L368 156.5L409.5 125L455 183Z',
        },
        {
          id: 'U4B',
          path:
            'M421.5 246.5L415 213.5L368 156.5L364.5 152.5L321 186.5L377.5 245L385 274L421.5 246.5Z',
        },
        {
          id: 'U4',
          path: 'M426.5 272.5L421.5 246.5L385 274L391.5 302.5L426.5 272.5Z',
        },
        {
          id: 'U5B',
          path:
            'M377.5 245L385 274L339 311.5L330 280.5L274 220L321 186.5L377.5 245Z',
        },
        { id: 'U6', path: 'M302 380L346.5 340L339 311.5L293 351.5L302 380Z' },
        { id: 'U7', path: 'M239.5 399L293 351.5L302 380L251 428.5L239.5 399Z' },
        {
          id: 'U7B',
          path:
            'M283.5 319L293 351.5L239.5 399L227.5 367L165 295.5L221 255L283.5 319Z',
        },
        {
          id: 'U8B',
          path:
            'M227.5 366.5L239.5 399L190.5 444L106.5 415.5L93 375.5L108.5 339.5L165 295.5L227.5 366.5Z',
        },
        {
          id: 'U8',
          path:
            'M201.791 473.431L116 445L107 415L191 443.5L191.137 443.874L240 399L251.5 428.5L202 474L201.791 473.431Z',
        },
        {
          id: 'U5',
          path: 'M391.5 302.5L385 274L339 311.5L346.5 340L391.5 302.5Z',
        },
        {
          id: 'U6B',
          path:
            'M330 280.5L274 220L221 255L283.5 319L293 351.5L339 311.5L330 280.5Z',
        },
        {
          id: 'U1B',
          path:
            'M520.5 127.5L522.5 157.5L492.5 183L489 154L444.5 99L479.5 71L520.5 127.5Z',
        },
        {
          id: 'U2B',
          path:
            'M409.5 125L444.5 99L489 154L492.5 183L458.5 214L455 183L409.5 125Z',
        },
        {
          id: 'U2',
          path: 'M494.5 213L492.5 183L458.5 214L462 241.5L494.5 213Z',
        },
      ],
    };
  },
  methods: {
    getClassForElement(el) {
      let apartment = this.apartments.find(apartment => {
        return apartment.id == el;
      });

      if (apartment) {
        return apartment.status.toLowerCase();
      } else {
        return '';
      }
    },
    hasApartment(el) {
      let apartment = this.apartments.find(apartment => {
        return apartment.id == el;
      });

      if (apartment) {
        return true;
      } else {
        return false;
      }
    },

    handleApartmentSelection(el) {
      let apartment = this.apartments.find(apartment => {
        return apartment.id == el;
      });
      if (apartment.status.toLowerCase() !== 'sprzedane') {
        this.$emit('selectorApartment', el);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/components/Selector.vue